<template>
  <div>
    <v-container>
      <v-layout wrap>
        <v-flex xs12 sm12>
          <h2>{{ $t('ตัวเลือกการสร้าง Custom Audience') }}</h2>
        </v-flex>
        <v-flex xs12 sm12 class="form-control mt-1">
          <div class="form-control pa-1" :class="{ 'has-error': errors.has(`name`) }">
            <input
              placeholder="ชื่อ Custom Audience"
              :data-vv-as="$t('name')"
              v-model="name"
              v-validate="'required'"
              :name="`name`"
              class="form-control mr-3"
              type="text"
            />
            <span class="text-error" v-if="errors.has(`name`)">{{ errors.first(`name`) }}</span>
          </div>
        </v-flex>
        <v-flex xs12 sm12 style="display: flex;" class="form-control mt-1">
          <toggle-button
            class="mt-1 mr-3"
            :value="allInbox"
            :sync="true"
            :color="$vuetify.theme.success"
            @change="onChangeLineNotify('notify_comment')"
            :labels="{ checked: 'ON', unchecked: 'OFF' }"
          />
          <h3><strong>ลูกค้าที่ทัก inbox (ทั้งหมด)</strong></h3>
        </v-flex>
        <v-flex xs12 sm12 style="display: flex;" class="form-control mt-3">
          <toggle-button
            class="mt-1 mr-3"
            :value="allInbox"
            :sync="true"
            :color="$vuetify.theme.success"
            @change="onChangeLineNotify('notify_comment')"
            :labels="{ checked: 'ON', unchecked: 'OFF' }"
          />
          <h3><strong>ลูกค้าที่ comment (ทั้งหมด)</strong></h3>
        </v-flex>
        <v-flex xs12 sm12 style="display: flex;" class="form-control mt-3">
          <toggle-button
            class="mt-1 mr-3"
            :value="allInbox"
            :sync="true"
            :color="$vuetify.theme.success"
            @change="onChangeLineNotify('notify_comment')"
            :labels="{ checked: 'ON', unchecked: 'OFF' }"
          />
          <h3><strong>ลูกค้าที่ทัก inbox (เฉพาะคีย์เวิร์ด)</strong></h3>
        </v-flex>
        <v-flex xs12 class="pl-2">
          <div class="arrow mt-2 pa-2" style="border: 1px solid #eee; border-radius: 5px">
            <span href="javascript:void(0);">
              {{ $t('(เช่น) 0.02 ค่าจัดส่ง  0.03 เก็บเงินปลายทาง, 0.05 วิธีการชำระเงิน') }}
            </span>
          </div>
        </v-flex>
        <v-flex xs12 sm12 style="display: flex;" class="form-control mt-3">
          <toggle-button
            class="mt-1 mr-3"
            :value="allInbox"
            :sync="true"
            :color="$vuetify.theme.success"
            @change="onChangeLineNotify('notify_comment')"
            :labels="{ checked: 'ON', unchecked: 'OFF' }"
          />
          <h3><strong>ลูกค้าที่ทัก comment (เฉพาะคีย์เวิร์ด)</strong></h3>
        </v-flex>
        <v-flex xs12 class="pl-2">
          <div class="arrow mt-2 pa-2" style="border: 1px solid #eee; border-radius: 5px">
            <span href="javascript:void(0);">
              {{ $t('(เช่น) 1.สนใจ, 2.โปรวาเลนไทน์') }}
            </span>
          </div>
        </v-flex>
        <v-flex xs12 sm12 class="form-control mt-3">
          <h3>
            <strong>{{ $t('Status') }}</strong>
          </h3>
          <multiselect
            v-model="update_status"
            :options="statusOptions"
            :searchable="true"
            selectLabel
            selectedLabel
            deselect-label
            :multiple="true"
            :placeholder="$t('Status')"
            @select="$emit('onChangeStatus')"
            @remove="$emit('onChangeStatus')"
          ></multiselect>
        </v-flex>
        <v-flex xs12 sm12 class="form-control mt-3">
          <h3>
            <strong>{{ $t('Tag') }}</strong>
          </h3>
          <multiselect
            v-model="update_tags"
            :options="tagOptions"
            :searchable="true"
            selectLabel
            selectedLabel
            deselect-label
            :multiple="true"
            :placeholder="$t('Tag')"
            @select="$emit('onChangeStatus')"
            @remove="$emit('onChangeStatus')"
          ></multiselect>
        </v-flex>
        <v-flex xs12 sm12 style="display: flex;" class="form-control mt-3">
          <toggle-button
            class="mt-1 mr-3"
            :value="allInbox"
            :sync="true"
            :color="$vuetify.theme.success"
            @change="onChangeLineNotify('notify_comment')"
            :labels="{ checked: 'ON', unchecked: 'OFF' }"
          />
          <h3><strong>ลูกค้าที่เคยซื้อผ่าน Shop Service</strong></h3>
        </v-flex>
        <v-flex xs12 sm12 style="display: flex;" class="form-control mt-3">
          <toggle-button
            class="mt-1 mr-3"
            :value="allInbox"
            :sync="true"
            :color="$vuetify.theme.success"
            @change="onChangeLineNotify('notify_comment')"
            :labels="{ checked: 'ON', unchecked: 'OFF' }"
          />
          <h3><strong>ลูกค้าที่มีสินค้าอยู่ในตะกร้า</strong></h3>
        </v-flex>
      </v-layout>
      <div class="text-xs-center mt-3"><v-btn depressed color="primary"> สร้าง </v-btn></div>
    </v-container>
  </div>
</template>

<script>
import { ToggleButton } from 'vue-js-toggle-button'
import { mapGetters } from 'vuex'
import api from '@/api'
import Multiselect from 'vue-multiselect'

export default {
  components: { ToggleButton, Multiselect },
  data() {
    return {
      name: null,
      allInbox: null,
      tagOptions: [],
      statusOptions: [],
      update_tags: [],
      update_status: []
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      userStatus: 'getUserStatus',
      loadingUserStatus: 'getLoadingUserStatus',
      userTags: 'getUserTags',
      loadingUserTags: 'getLoadingUserTags'
    })
  },
  mounted: function() {
    this.getUserStatusList()
    this.getUserTagList()
  },
  methods: {
    addUserTags: function(newTags) {
      console.log(newTags)
      this.usertags = newTags
    },
    async getUserStatusList() {
      const vm = this
      await vm.$store.dispatch('loadStatus')
      if (vm.userStatus.length > 0) {
        vm.statusOptions = vm.userStatus.map(item => {
          return item.name
        })
      }
    },
    async getUserTagList() {
      const vm = this
      await vm.$store.dispatch('loadTags')
      if (vm.userTags.length > 0) {
        vm.tagOptions = vm.userTags.map(item => {
          return item.name
        })
      }
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/customAudience/CustomAudience.vue